import React from 'react';

import * as ChemistryDAO from 'chemistry/ChemistryDAO';
import * as SidebarConstants from 'sidebar/SidebarConstants';

import EmptySidebarIcon from './EmptySidebarIcon';
import SidebarItem from './SidebarItem';

interface ChemistrySettingsProps {
  section: SidebarConstants.Section;
}

export default function ChemistrySettings({section}: ChemistrySettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Chemistry Settings</div>
      <SidebarItem
        active={section === SidebarConstants.Section.SALT_LIBRARY}
        icon={<EmptySidebarIcon />}
        name="Salt library"
        link={ChemistryDAO.SALT_LIBRARY_URL}
      />
      <SidebarItem
        active={section === SidebarConstants.Section.SOLVENT_LIBRARY}
        icon={<EmptySidebarIcon />}
        name="Solvent library"
        link={ChemistryDAO.SOLVENT_LIBRARY_URL}
      />
    </div>
  );
}
